import { List, ListItem } from '@chakra-ui/react';

import { trpc } from '../config/trpc';

export const BookingWarnings = ({ quoteVariantId }: { quoteVariantId: number }) => {
  const { data } = trpc.getBookingWarnings.useQuery({ id: quoteVariantId });

  if (!data?.results?.length) return null;

  return (
    <List>
      {data?.results?.map?.((filter) => (
        <ListItem key={filter?.id} textStyle="captionSmallRegular">
          {filter.meta?.['text']}
        </ListItem>
      ))}
    </List>
  );
};
